import React from "react";

export default function Lead() {
  return (
    // <div className="bg-gray-100 dark:bg-gray-900 rounded-lg p-1 sm:p-3 shadow-lg text-sm">
    <div>
      
    </div>
  );
}
